import React, { Component } from "react";
import { styles } from "./styles";
import { registerInstance } from "./controller";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { getGridLineColor } from '../../helpers/utils'

class PopupDevicesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      devices: [],
      onSelect: null,
    };
  }

  componentDidMount() {
    registerInstance(this);
  }

  /** MÉTODO GLOBAL */
  open = (devices, onSelect) => {
    this.setState({
      open: true,
      devices,
      onSelect,
    });
  };

  /** FECHAR LOCAL OU GLOBAL */
  close = () => {
    this.setState({ open: false });
  };

  render() {
    const { open, devices, onSelect } = this.state;

    if (!open) return null;

    return (
        <div style={styles.backdrop} onClick={this.close}>
            <div style={styles.modal} className="card-chart card" onClick={(e) => e.stopPropagation()}>
                <h3 style={{color: "inherit"}}>Selecionar dispositivo para onde a página será duplicada</h3>
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {devices.map((item, index) => (
                    <Card
                    key={index}
                    onClick={() => {
                        if (onSelect) onSelect(item);
                        this.close();
                    }}
                    style={{ cursor: "pointer", marginBottom: "0px" }}
                    className="card-chart"
                    >
                        <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
                        <Row>
                        <Col style={{ display: "flex", alignItems: "center" }}>
                            {item.deviceId} - {item.title}
                        </Col>
                        </Row>
                    </CardBody>
                    </Card>
                ))}
                </div>
                <div style={{textAlign: "right"}}>
                    <Button className="btn-fill btn-xs" color="danger"onClick={this.close}>Fechar</Button>
                </div>
            </div>
        </div>
        );
    }
}

export default PopupDevicesComponent;
